import { render, staticRenderFns } from "./DepositIndex.vue?vue&type=template&id=2ab74be2"
import script from "./DepositIndex.vue?vue&type=script&lang=js"
export * from "./DepositIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports